const Portfolio = () => {
  return (
    <div className="page-container">
      Portfolio
    </div>
  )
}

export default Portfolio